module.exports = __webpack_public_path__ + "static/media/backend.a42040d5.svg";